"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = paramsMiddleware;

var _reduxApiMiddleware = require("redux-api-middleware");

var _qs = require("qs");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function parametriseEndpoint(endpoint, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    arrayFormat: 'indices'
  };

  var _endpoint$split = endpoint.split('?'),
      _endpoint$split2 = _slicedToArray(_endpoint$split, 2),
      pure = _endpoint$split2[0],
      _endpoint$split2$ = _endpoint$split2[1],
      query = _endpoint$split2$ === void 0 ? '' : _endpoint$split2$;

  return pure + '?' + (0, _qs.stringify)(_objectSpread({}, (0, _qs.parse)(query), params), options);
}

function paramsMiddleware() {
  return function (next) {
    return function (action) {
      var apiCall = action[_reduxApiMiddleware.RSAA];

      if (!apiCall || !apiCall.params || typeof apiCall.endpoint === 'function') {
        return next(action);
      }

      var endpoint = apiCall.endpoint,
          params = apiCall.params,
          paramsOptions = apiCall.paramsOptions,
          rest = _objectWithoutProperties(apiCall, ["endpoint", "params", "paramsOptions"]);

      return next(_defineProperty({}, _reduxApiMiddleware.RSAA, _objectSpread({}, rest, {
        endpoint: parametriseEndpoint(endpoint, params, paramsOptions)
      })));
    };
  };
}